import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconFullCurveUp = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_3072_85511)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.5318 10.1756C13.6288 10.4341 13.917 10.5651 14.1756 10.4682C14.4341 10.3712 14.5651 10.083 14.4682 9.82444L13.5318 10.1756ZM1.53184 9.82444C1.43488 10.083 1.56588 10.3712 1.82444 10.4682C2.083 10.5651 2.3712 10.4341 2.46816 10.1756L1.53184 9.82444ZM14.4682 9.82444C12.2269 3.84785 3.77306 3.84785 1.53184 9.82444L2.46816 10.1756C4.38495 5.06414 11.6151 5.06414 13.5318 10.1756L14.4682 9.82444Z",
        fill: "black"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_3072_85511"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 16,
        height: 16,
        fill: "white"
    }))));

export { IconFullCurveUp };
